module.exports = ".btn {\n  display: block; }\n  .btn.save {\n    margin-left: auto; }\n  .btn.add-element-btn {\n    pointer-events: none; }\n  .btn.add-element-btn:disabled {\n    background: grey;\n    border-color: grey; }\n  .btn.hidden {\n    display: none; }\n  .add-element {\n  display: inline-block;\n  margin-bottom: 1rem; }\n  .table-experiment-list td {\n  max-width: 150px; }\n  .modal-footer .btn {\n  margin: 0; }\n  .modal-footer .btn:last-child {\n    margin-left: 1rem; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/provider/form/form.component.scss
// module id = ./src/app/modules/provider/form/form.component.scss
// module chunks = main